import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatStepperModule } from "@angular/material/stepper";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenEntityFormCardComponent } from "./components/loren-entity-form-card/loren-entity-form-card.component";
import { LorenCardModule } from "../loren-card/loren-card.module";
import { LorenEntityFormModule } from "../loren-entity-form/loren-entity-form.module";
import { LorenSharedDirectivesModule } from "../../directives/loren-shared-directives.module";
import {DragDropModule} from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [LorenEntityFormCardComponent],
  exports: [LorenEntityFormCardComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    LorenCardModule,
    ReactiveFormsModule,

    MatInputModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    MatSelectModule,
    MatCheckboxModule,
    LorenEntityFormModule,
    TranslocoModule,
    LorenSharedDirectivesModule,
    MatStepperModule,
      DragDropModule
  ],
})
export class LorenEntityFormCardModule {}
